import { component$ } from "@builder.io/qwik";
import ICFBPLogo from "~/img/icfbp-logo.svg?jsx";
import { cn } from "~/lib/cn";

export const IcfPartnerBox = component$<{ class?: string }>(
  ({ class: className }) => {
    return (
      <div class={cn("flex flex-col items-stretch", className)}>
        <ICFBPLogo width={300} class="-ml-5 mb-4" />
        <h3 class="font-heading text-primary mb-4 text-lg font-semibold leading-tight tracking-tight">
          Dream Coach Match is proud to be a Business Partner of the{" "}
          <a
            href="https://coachingfederation.org/partner/dream-coach-match/"
            class="text-brand-700 underline hover:no-underline"
          >
            International Coaching Federation (ICF)
          </a>
          .
        </h3>
        <p class="text-secondary text-sm">
          The ICF is the world's largest network of trained coaching
          professionals, with over 55,000 certified coaches across 158
          countries. Together, we're advancing the coaching profession and
          connecting you with trusted, top-tier coaches.
        </p>
      </div>
    );
  },
);
